import { Helmet } from 'react-helmet-async';

// Canonical domain - all URLs must use this as the base
export const CANONICAL_DOMAIN = 'https://gistgift.shop';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
}

const SEOHead = ({ title, description, canonical, ogImage = '/screenshots/gistgift-results.png' }: SEOHeadProps) => {
  // Normalize the canonical path - remove trailing slashes, ensure leading slash
  const normalizedPath = canonical === '/' ? '' : canonical.replace(/\/+$/, '');
  const fullCanonical = `${CANONICAL_DOMAIN}${normalizedPath}`;
  const fullOgImage = `${CANONICAL_DOMAIN}${ogImage}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content="website" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
    </Helmet>
  );
};

export default SEOHead;
